<template>
  <transition name="modal-fade">
    <div class="modal" role="dialog" id="data-set-extension-modal">
      <header class="modal-header" style="background-color: white">
        <i v-show="loading" class="far fa-spinner fa-spin" />
        <slot name="header">
          <h3>{{ i18nJS.dati_impegnativa }}</h3>
        </slot>
      </header>
      <body class="modal-body">
        <slot name="body">
          <div v-if="errors.length">
            <b style="color: #ef7b12">{{ i18nJS.error_message }}</b>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.impegnativa }}</label>
            <div class="controls">
              <input
                v-if="guest_period_data_set_extension === null"
                type="text"
                class="form-control"
                v-model="data.protocol_name"
                required
              />
              <input
                v-else
                type="text"
                class="form-control"
                v-model="editData.protocol_name"
                @input="(val) => (data.protocol_name = val)"
              />
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.data_inizio }}</label>
            <div class="controls">
              <datepicker
                v-if="guest_period_data_set_extension === null"
                class="input_date"
                :value="data.datein"
                @input="(val) => (data.datein = val)"
                required
              />
              <datepicker v-else class="input_date" disabled :value="dateIn()" />
              <i style="color: #ef7b0f" class="fa-light fa-calendar-days fa-lg"></i>
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.date_asl_protocol }}</label>
            <div class="controls">
              <datepicker
                v-if="guest_period_data_set_extension === null"
                class="input_date"
                :value="data.date_asl_protocol"
                @input="(val) => (data.date_asl_protocol = val)"
                required
              />
              <datepicker v-else class="input_date" disabled :value="editData.date_asl_protocol" />
              <i style="color: #ef7b0f" class="fa-light fa-calendar-days fa-lg"></i>
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.durata_impegnativa }}</label>
            <div class="controls">
              <input
                v-if="guest_period_data_set_extension === null"
                type="number"
                min="0"
                max="100"
                class="form-control"
                style="width: 60px"
                id="duration-dates"
                v-model="data.duration"
                required
              />
              <input v-else type="number" min="0" max="100" class="form-control" disabled style="width: 60px" v-model="editData.duration" />
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.data_fine }}</label>
            <div class="controls">
              <datepicker v-if="guest_period_data_set_extension === null" class="input_date" required :value="editDate()" />
              <datepicker v-else class="input_date" disabled :value="dateOut()" />
              <i style="color: #ef7b0f" class="fa-light calendar-days fa-lg"></i>
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.num_trattamenti }}</label>
            <div class="controls">
              <input
                v-if="guest_period_data_set_extension === null"
                type="number"
                min="0"
                max="100"
                class="form-control"
                style="width: 60px"
                v-model="data.nrgg_autorizzate"
                required
              />
              <input
                v-else
                type="number"
                min="0"
                max="100"
                class="form-control"
                disabled
                style="width: 60px"
                v-model="editData.nrgg_autorizzate"
              />
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.notes }}</label>
            <div class="controls">
              <textarea v-if="guest_period_data_set_extension === null" rows="4" cols="50" v-model="data.notes" />
              <textarea v-else rows="4" cols="50" v-model="editData.notes" />
            </div>
          </div>
          <div class="control-group">
            <label class="control-label">{{ i18nJS.week_trattements_days }}</label>
            <div class="controls">
              <input
                v-if="guest_period_data_set_extension === null"
                type="number"
                min="0"
                max="100"
                class="form-control"
                style="width: 60px"
                v-model="data.week_trattements"
                required
              />
              <input
                v-else
                type="number"
                min="0"
                max="100"
                class="form-control"
                disabled
                style="width: 60px"
                v-model="editData.week_trattements"
              />
            </div>
          </div>
          <div class="control-group">
            <label>{{ i18nJS.week_trattements }}</label>
            <div>
              <select v-model="trattement_days_data.tag">
                <option v-for="tag in tags_list" :key="tag">
                  {{ tag }}
                </option>
              </select>
              <input
                type="number"
                min="0"
                max="100"
                class="form-control"
                style="width: 60px"
                v-model="trattement_days_data.trattement_days"
              />
              <span data-original-title="Nuovo" @click="addTrattementDay" class="fa-light fa-plus pulsante_comando js-tooltip"></span>
            </div>
            <table v-if="data.extra_fields && Object.keys(data.extra_fields).length > 0" class="table fixed_header">
              <thead>
                <tr class="heading">
                  <th style="width: 100px">{{ i18nJS.tag }}</th>
                  <th style="width: 100px">{{ i18nJS.days }}</th>
                  <td style="width: 10px"></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tag in Object.keys(data.extra_fields)" :key="tag">
                  <td>{{ tag }}</td>
                  <td>{{ data.extra_fields[tag] }}</td>
                  <td>
                    <a @click="deleteTrattementDay(tag)">
                      <i style="color: red" class="fa-light fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="guest_period_data_set_extension !== null" class="control-group">
            <button type="button" class="btn-close" @click="showProgForm">
              <i class="fa-light fa-plus">{{ i18nJS.proroga }}</i>
            </button>
          </div>
          <div v-if="showProg" class="control-group">
            <label class="control-label">{{ i18nJS.data_proroga }}</label>
            <div class="controls">
              <datepicker class="input_date" :value="data.dateprog" @input="(val) => (data.dateprog = val)" required />
              <i style="color: #ef7b0f" class="fa-light calendar-days fa-lg"></i>
            </div>
          </div>
          <div v-if="showProg" class="control-group">
            <label class="control-label">{{ i18nJS.validita_proroga }}</label>
            <div class="controls">
              <input type="number" min="0" max="100" class="form-control" style="width: 60px" v-model="data.duration" required />
            </div>
          </div>
          <div v-if="showProg" class="control-group">
            <label class="control-label">{{ i18nJS.end_date_prog }}</label>
            <div class="controls">
              <datepicker class="input_date" :value="editDateFineProg()" required />
              <i style="color: #ef7b0f" class="fa-light calendar-days fa-lg"></i>
            </div>
          </div>
          <div v-if="showProg" class="control-group">
            <label class="control-label">{{ i18nJS.residue }}</label>
            <div class="controls">
              <input
                type="number"
                disabled
                min="0"
                max="100"
                class="form-control"
                style="width: 60px"
                v-model="editData.residue"
                required
              />
            </div>
          </div>
        </slot>
      </body>
      <footer class="modal-footer">
        <slot name="footer">
          <a v-if="guest_period_data_set_extension === null" @click="save" class="btn btn-primary">{{ i18nJS.save }}</a>
          <a v-else @click="update" class="btn btn-warning">{{ i18nJS.update }}</a>
          <a @click="closeModal" class="btn btn-success">{{ i18nJS.close }}</a>
        </slot>
      </footer>
    </div>
  </transition>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../datepicker';

export default {
  name: 'DataSetExtensionFormModal',
  props: ['guest_period_data_set_id', 'guest_period_data_set_extension', 'list_gpdse', 'list_trattements'],
  components: {
    datepicker,
  },
  data() {
    return {
      data: {
        protocol_name: null,
        datein: null,
        dateout: null,
        duration: null,
        dateprog: null,
        date_asl_protocol: null,
        date_fineprog: null,
        nrgg_autorizzate: null,
        notes: '',
        guest_period_data_set_id: this.guest_period_data_set_id,
        guest_period_data_set_extension_id: null,
        extra_fields: {},
        week_trattements: null,
      },
      editData: {
        protocol_name: null,
        datein: null,
        dateout: null,
        duration: null,
        dateprog: null,
        date_asl_protocol: null,
        nrgg_autorizzate: null,
        notes: '',
        guest_period_data_set_id: this.guest_period_data_set_id,
        guest_period_data_set_extension_id: null,
        residue: null,
        extra_fields: {},
        week_trattements: null,
      },
      showProg: false,
      residue: null,
      loading: false,
      errors: [],
      base_url: window.config.ePersonamService.ePersonamHost + '/' + window.locale,
      trattement_days_data: {
        days: null,
        tag: null,
      },
      tags_list: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    this.fillData();
    document.getElementById('data-set-extension-modal').classList.remove('hide');
    apiConnector()
      .get(this.base_url + '/activities_configs/get_tags_list.json')
      .then((res) => {
        this.tags_list = res.data;
      })
      .catch((err) => {
        console.log('Errore nel caricamento della lista dei tags delle attività', err);
      });
  },
  watch: {
    guest_period_data_set_extension: function () {
      this.fillData();
    },
  },
  methods: {
    fillData() {
      if (this.guest_period_data_set_extension) {
        this.editData.protocol_name = this.guest_period_data_set_extension.protocol_name;
        this.editData.datein = this.guest_period_data_set_extension.datein;
        this.editData.dateout = this.guest_period_data_set_extension.dateout;
        this.editData.duration = this.guest_period_data_set_extension.duration;
        this.editData.dateprog = this.guest_period_data_set_extension.dateprog;
        this.editData.date_asl_protocol = this.guest_period_data_set_extension.date_asl_protocol;
        this.editData.nrgg_autorizzate = this.guest_period_data_set_extension.nrgg_autorizzate;
        this.editData.notes = this.guest_period_data_set_extension.notes;
        this.editData.guest_period_data_set_id = this.guest_period_data_set_id;
        this.editData.guest_period_data_set_extension_id = this.guest_period_data_set_extension_id;
        this.editData.residue = this.guest_period_data_set_extension.residue;
        this.editData.extra_fields = this.guest_period_data_set_extension.extra_fields;
        this.editData.week_trattements = this.guest_period_data_set_extension.week_trattements;
        this.data.extra_fields = this.list_trattements;
      } else {
        this.cleanModal();
      }
    },
    addTrattementDay() {
      if (this.trattement_days_data.trattement_days && this.trattement_days_data.tag) {
        const days = this.trattement_days_data.trattement_days;
        const tag = this.trattement_days_data.tag;
        this.$set(this.data.extra_fields, tag, days);
        this.trattement_days_data.trattement_days = null;
        this.trattement_days_data.tag = null;
      }
    },
    deleteTrattementDay(tag) {
      this.$delete(this.data.extra_fields, tag);
    },
    editDateFineProg() {
      if (this.data.dateprog && this.data.duration) {
        let new_date = moment(this.data.dateprog.toString(), 'DD-MM-YYYY').add(this.data.duration, 'days');
        new_date = new_date.format('DD/MM/YYYY');
        this.data.date_fineprog = new_date;
        return new_date;
      }
    },
    editDate() {
      if (this.data.datein && this.data.duration) {
        let new_date = moment(this.data.datein.toString(), 'DD-MM-YYYY').add(this.data.duration, 'days');
        new_date = new_date.format('DD/MM/YYYY');
        this.data.dateout = new_date;
        return new_date;
      }
    },
    showProgForm() {
      this.showProg ? (this.showProg = false) : (this.showProg = true);
      this.data.duration = null;
    },
    closeModal() {
      this.cleanModal();
      document.getElementById('data-set-extension-modal').classList.add('hide');
      eventBus.$emit('gpdseModalClosed');
    },
    save() {
      this.errors = [];
      this.checkErrorsSave();
      if (this.errors.length === 0) {
        document.getElementById('data-set-extension-modal').classList.add('hide');
        eventBus.$emit('gpdseModalClosed');
        Loader.show();
        apiConnector()
          .post(
            this.base_url + '/guest_period_data_sets/' + this.guest_period_data_set_id + '/guest_period_data_sets_extensions.json',
            this.data,
          )
          .then((res) => {
            // eslint-disable-next-line vue/no-mutating-props
            this.list_gpdse.push(res.data[0]);
            Loader.hide();
          })
          .catch((err) => {
            document.getElementById('data-set-extension-modal').classList.add('hide');
            eventBus.$emit('gpdseModalClosed');
            console.log('Errore nella creazione', err);
            Loader.hide();
          });
      }
    },
    update() {
      this.errors = [];
      this.checkErrorsUpdate();
      if (this.errors.length === 0) {
        let params = {};
        if (!this.data.dateprog) {
          params = { protocol_name: this.editData.protocol_name, notes: this.editData.notes, extra_fields: this.data.extra_fields };
        } else {
          params = {
            protocol_name: this.editData.protocol_name,
            datein: this.editData.datein,
            dateout: this.editData.dateout,
            duration: this.data.duration,
            dateprog: this.data.dateprog,
            date_fineprog: this.data.date_fineprog,
            nrgg_autorizzate: this.editData.nrgg_autorizzate,
            notes: this.editData.notes,
            guest_period_data_set_id: this.guest_period_data_set_id,
            guest_period_data_set_extension_id: this.guest_period_data_set_extension.id,
            extra_fields: this.data.extra_fields,
            week_trattements: this.data.week_trattements,
          };
        }
        document.getElementById('data-set-extension-modal').classList.add('hide');
        eventBus.$emit('gpdseModalClosed');
        Loader.show();
        apiConnector()
          .put(
            this.base_url +
              '/guest_period_data_sets/' +
              this.guest_period_data_set_id +
              '/guest_period_data_sets_extensions/' +
              this.guest_period_data_set_extension.id,
            params,
          )
          .then((res) => {
            if (res.data.length > 1) {
              const index = this.list_gpdse.findIndex((gpdse) => gpdse.id === res.data[0].id);
              // eslint-disable-next-line vue/no-mutating-props
              this.list_gpdse.splice(index, 1);
              // eslint-disable-next-line vue/no-mutating-props
              this.list_gpdse.splice(index, 0, res.data[0]);
              // eslint-disable-next-line vue/no-mutating-props
              this.list_gpdse.push(res.data[1]);
            } else {
              const index = this.list_gpdse.findIndex((gpdse) => gpdse.id === res.data[0].id);
              // eslint-disable-next-line vue/no-mutating-props
              this.list_gpdse.splice(index, 1);
              // eslint-disable-next-line vue/no-mutating-props
              this.list_gpdse.splice(index, 0, res.data[0]);
            }
            Loader.hide();
          })
          .catch((err) => {
            document.getElementById('data-set-extension-modal').classList.add('hide');
            eventBus.$emit('gpdseModalClosed');
            console.log('Errore nel aggiornamento', err);
            Loader.hide();
          });
      }
    },
    checkErrorsSave() {
      if (!this.data.protocol_name || this.editData.protocol_name === '') this.errors.push(i18nJS.mandatory_protocol_name);
      if (!this.data.datein) this.errors.push(i18nJS.mandatory_datein);
      if (!this.data.dateout) this.errors.push(i18nJS.mandatory_dateout);

      if (!this.data.duration) {
        this.errors.push(i18nJS.mandatory_duration);
      } else if (this.data.duration < 0) {
        this.errors.push(i18nJS.negative_duration);
      }
      if (this.data.nrgg_autorizzate === null) {
        this.errors.push(i18nJS.mandatory_trattamenti);
      } else if (this.data.nrgg_autorizzate < 0) {
        this.errors.push(i18nJS.negative_trattamenti);
      }
      if (this.data.datein && this.data.dateout) {
        let datein = Date.parse(this.data.datein.toString());
        let dateout = Date.parse(this.data.dateout.toString());
        if (dateout < datein) this.errors.push(i18nJS.datein_dateout_range);
      }
    },
    checkErrorsUpdate() {
      if (!this.editData.protocol_name || this.editData.protocol_name === '') this.errors.push(i18nJS.mandatory_protocol_name);

      if (this.showProg) {
        if (!this.data.duration) {
          this.errors.push(i18nJS.mandatory_dateprog);
        } else if (this.data.duration < 0) {
          this.errors.push(i18nJS.negative_duration_prog);
        }
        if (!this.data.dateprog) this.errors.push(i18nJS.mandatory_dateprog);
      }
    },
    dateIn() {
      if (this.editData.datein) return moment(this.editData.datein).format('DD/MM/YYYY');
    },
    dateOut() {
      if (this.editData.dateout) return moment(this.editData.dateout).format('DD/MM/YYYY');
    },
    cleanModal() {
      this.data.protocol_name = null;
      this.data.datein = null;
      this.data.dateout = null;
      this.data.duration = null;
      this.data.dateprog = null;
      this.data.notes = null;
      this.data.nrgg_autorizzate = null;
      this.data.notes = null;
      this.data.guest_period_data_set_id = null;
      this.data.guest_period_data_set_extension_id = null;
      this.data.week_trattements = null;
      this.data.extra_fields = {};
      this.data.date_asl_protocol = null;
      this.showProg = false;
      this.errors = [];
      this.trattement_days_data.trattement_days = null;
      this.trattement_days_data.tag = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  z-index: -1;
}
</style>
